namespace Elmish.UrlBuilder

[<RequireQualifiedAccess>]
module internal Helper =
    /// **Description**
    ///
    /// Get all of the indexes for a substring in another string.
    ///
    /// ```
    /// Helper.indexes "i" "Mississippi" = [ 1; 4; 7; 10 ]
    /// Helper.indexes "ss" "Mississippi" = [ 2; 5 ]
    /// Helper.indexes "needle" "haystack" = []
    /// ```
    ///
    /// **Parameters**
    ///   * `sub` - parameter of type `string`
    ///   * `str` - parameter of type `string`
    ///
    /// **Output Type**
    ///   * `int list`
    let indexes (sub : string) (str : string) : int list =
        let subLen = sub.Length
        if subLen < 1 then []
        else
            let mutable i = 0
            let mutable is = []
            while ((i <- str.IndexOf(sub, i)
                    i) > -1) do
                is <- i :: is
                i <- i + subLen
            is |> List.rev

    /// **Description**
    ///
    /// Drop `n` characters from the left side of a string.
    ///
    /// ```
    /// Helper.dropLeft 2 "The Lone Gunmen" = "e Lone Gunmen"
    /// Helper.dropLeft 0 "The Lone Gunmen" = "The Lone Gunme"
    /// Helper.dropLeft -1 "The Lone Gunmen" = "The Lone Gunmen"
    /// ```
    /// **Parameters**
    ///   * `n` - parameter of type `int`
    ///   * `str` - parameter of type `string`
    ///
    /// **Output Type**
    ///   * `string`
    let dropLeft (n : int) (str : string) : string =
        str.ToCharArray()
        |> Array.skip n
        |> System.String

    /// **Description**
    ///
    /// Reduce a string from the left.
    ///
    /// ```
    /// Helper.left 2 "Mulder" = "Mu"
    /// Helper.left 0 "Mulder" = ""
    /// Helper.left -1 "Mulder" = ""
    /// ```
    ///
    /// **Parameters**
    ///   * `n` - parameter of type `int`
    ///   * `str` - parameter of type `string`
    ///
    /// **Output Type**
    ///   * `string`
    let left (n : int) (str : string) =
        str.ToCharArray()
        |> Array.take n
        |> System.String

    /// **Description**
    ///
    /// Try cast string to int.
    ///
    /// ```
    /// Helper.toInt "1" = Some 1
    /// Helper.toInt "a" = None
    /// ```
    ///
    /// **Parameters**
    ///   * `str` - parameter of type `string`
    ///
    /// **Output Type**
    ///   * `Option<int>`
    let toInt (str : string) : Option<int> =
        match System.Int32.TryParse str with
        | true, num -> Some num
        | _ -> None
